import PageLayout from '@/components/page/page-layout'

const DataList = () => import('@/views/data/list')
const DataActivityDetail = () => import('@/views/data/detail/activity')

const router = {
  path: '/data',
  component: PageLayout,
  redirect: '/data/list',
  name: 'Data',
  icon: 'none',
  children: [
    {
      path: 'list',
      name: 'dataList',
      component: DataList,
      meta: {
        currentMenu: 'data',
        hideBreadcrumb: true,
        title: '数据统计'
      }
    },
    {
      path: 'detail/activity',
      name: '活动数据详情',
      component: DataActivityDetail,
      meta: {
        currentMenu: 'data',
        hideBreadcrumb: true,
        title: '活动数据详情'
      }
    }
  ]
}

export default router
